import { render, staticRenderFns } from "./ActivitySubmissionElement.vue?vue&type=template&id=07b8fe23&scoped=true"
import script from "./ActivitySubmissionElement.vue?vue&type=script&lang=js"
export * from "./ActivitySubmissionElement.vue?vue&type=script&lang=js"
import style0 from "./ActivitySubmissionElement.vue?vue&type=style&index=0&id=07b8fe23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8fe23",
  null
  
)

export default component.exports